/**
 * 预约挂号相关
 */

import http from "@/utils/axiosoUtil";

const mutations = {
  setDepartmentList(state, departmentList) {
    state.departmentList = departmentList;
  },
  setDoctorList(state, doctorList) {
    state.doctorList = doctorList;
  }
};

const state = {
  departmentList: [],
  doctorList: []
};

const actions = {
  // 获取科室列表
  initDepartmentList({ commit }) {
    http.get(http.api.APPOINTMENT_DEPARTMENT_LIST).then(res => {
      const departmentList = res.map(item => {
        return {
          title: item.outpatientOfficeName,
          id: item.deptCode
        };
      });
      commit("setDepartmentList", departmentList);
    });
  },
  // 获取医生列表
  initDoctorList({ commit }) {
    http.get(http.api.APPOINTMENT_DOCTOR_LIST).then(res => {
      const departmentList = res.map(item => {
        let dateList = [];
        if (item.dates) {
          dateList = item.dates.map(date => {
            return {
              date: date.appointmentDate,
              timeFrame: date.timeFrame,
              week: date.week
            };
          });
        }

        return {
          doctorName: item.doctorName,
          title: item.level,
          gender: item.sex,
          introduction: item.speciality,
          portrait: item.photourl,
          dateList
        };
      });
      commit("setDoctorList", departmentList);
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
